export const MetaParser = {
  meta ({ current_page: page, total_entries: total, total_pages: totalPages }) {
    return {
      page,
      total,
      totalPages
    }
  }
}
